import { useCallback, useContext } from 'react';
import { SET_ATTRIBUTES } from '../context/actions';
import { getAttributes } from '../api/attributes';
import { ErrorContext } from '../api/error-boundary';

export function useInitAttributes(pimLanguage: string, dispatch: (value: any) => void) {
  const errorContext = useContext(ErrorContext);

  return useCallback(async () => {
    let response;
    try {
      response = await getAttributes(pimLanguage);
      if (response?.data && response.error === 0) {
        const { attributes } = response.data;
        dispatch({
          type: SET_ATTRIBUTES,
          attributes,
        });
      }
    } catch (e) {
      console.error(e);
      errorContext?.setError((e as any).message);
    }
  }, [pimLanguage, dispatch, errorContext]);
}
